var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5883 9.25106C12.2629 8.91631 11.7345 8.91631 11.4091 9.25106L7.24405 13.5358C6.91865 13.8706 6.91865 14.4142 7.24405 14.7489C7.56944 15.0837 8.09788 15.0837 8.42327 14.7489L12 11.0694L15.5767 14.7463C15.9021 15.081 16.4306 15.081 16.756 14.7463C17.0813 14.4115 17.0813 13.8679 16.756 13.5331L12.5909 9.24838L12.5883 9.25106Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIco);
export default __webpack_public_path__ + "static/media/Collapse_ico.cd97c2fb43b10c2e09654ad5febd6cbe.svg";
export { ForwardRef as ReactComponent };